import { Box, List, ListItemText, Stack, Typography } from "@mui/material";
import { UFooter, UMargin, URow, USection } from "../common/ui.page";
import { CBackToMain } from "../components/cr.ui.buttons";
import { CPage, CSection } from "../components/cr.ui.page";
import { useOrder } from "../components/order";
import { UEditableTextField } from "../common/ui.editable";
import { GREY, SECONDARY_COLOR } from "../style/theme";
import { UImage } from "../common/ui.icon";
import { CDocument, CMatch, CMatchButton, CMatchDetails, CMatchJoin, CPlayer } from "../components/cr.ui.crusade";
import { CAdmin } from "../components/cr.ui.admin";
import { useCrusade } from "../components/crusade";
import { CExtPlayerList } from "../components/cr.ext";
import { useExt } from "../components/ext";
import { MvpList } from "../components/cr.ui.mvp";


export function PageCrusade(props) {
    const order = useOrder()

    return <CPage>
        <CBackToMain codex={order.codex.name} />

        <USection >
            <TopPanel />
        </USection>

        <Stack spacing={2}>
            <ListToPlay />
            <CMvpList />
            <CExtPlayerList />
            <ListPlayed />
            <ListDocuments />
        </Stack>

    </CPage>
}


function TopPanel() {
    const order = useOrder()
    return <URow>
        <Stack sx={{
            textAlign: 'right',
            flex: 1,
            paddingX: 1,
            paddingBottom: 2,
        }}>
            <Typography sx={{ fontSize: 12 }}>
                {order.codex.name}
            </Typography>
            <UEditableTextField
                restCommit="player/edit/name"
                onComplete={order.reload}
                sx={{ color: GREY[900], fontWeight: 500 }}
                defValue={"Set player name"}
                value={order.player.name}
            />
        </Stack>
        <Box sx={{
            position: 'relative',
            width: 164,
            marginTop: -15,
        }}>
            <Box sx={{
                border: '9px solid ' + GREY[100],
                lineHeight: 0,
                position: 'absolute',
            }}>
                <UImage src="/static/bg/bg-crusade-1.png" />
            </Box>
        </Box>
    </URow>
}


function ListToPlay() {
    const order = useOrder()
    const crusade = useCrusade()

    const matches = crusade.matches.filter(m => m.status == 'init');

    if (matches.length == 0) {
        return <></>
    }

    return <CSection>
        <Stack>
            <Typography sx={{ color: GREY[800], fontWeight: 500, }}>Partite da giocare</Typography>

            <List>
                {matches.map(m => <CMatchJoin
                    warnRequisition={order.rp > 5}
                    warnRestore={order.restoreMarkedRemaining + order.restoreXpRemaining > 0}
                    key={m.id}
                    joinCall={'match/' + crusade.id + '-' + m.id + '/join'}
                    changeSelectedPointsCall={'match/' + crusade.id + '-' + m.id + '/points/update'}
                    onJoin={crusade.reload}
                    units={order.units}
                    match={m}
                    button={<CMatchButton
                        alert={m.joined ? undefined : '!'}
                        primary={m.name}
                        secondary={new Date(m.date).toLocaleDateString('it-IT')} color={m.joined ? GREY[800] : SECONDARY_COLOR} />} />
                )}

            </List>

        </Stack>
    </CSection>
}

function CMvpList() {
    return <CSection>
        <Typography sx={{ color: GREY[800], fontWeight: 500, }}>I più temibili</Typography>
        <MvpList />
    </CSection>
}


function ListPlayed() {
    const order = useOrder()
    const crusade = useCrusade()
    const ext = useExt()

    const matches = crusade.matches.filter(m => m.status == 'done');

    if (matches.length == 0) {
        return <></>
    }

    return <CSection>
        <Stack>
            <Typography sx={{ color: GREY[800], fontWeight: 500, }}>Partite giocate</Typography>

            <List>
                {ext.matchesListPlayed(matches)}
            </List>

        </Stack>
    </CSection>
}

const DOCUMENTS = [
    {
        name: '10th Crusade',
        id: 'doc-crusade-core',
    },
    {
        name: 'Tyranic War',
        id: 'doc-tyranic-war',
    },
    {
        name: 'Pariah Nexus',
        id: 'doc-pariah-nexus',
    },
]
function ListDocuments(props) {
    const ext = useExt()
    return <CSection>
        <Stack>
            <Typography sx={{ color: GREY[800], fontWeight: 500, }}>Documenti</Typography>

            <List>
                {DOCUMENTS.filter(d => ext.docs.includes(d.id)).map(m => <CDocument key={m.name} name={m.name} pdf={m.id + '.pdf'} />
                )}

            </List>

        </Stack>
    </CSection>
}